import type { TwoFactorHints } from "./types";

interface MfaSession {
    mfaSessionToken: string;
    username: string;
    password: string;
    twoFactorMethods: string[];
    userId: string;
    hints: TwoFactorHints;
}

let session: MfaSession | null = null;

export function setMfaSession(data: MfaSession) {
    session = data;
}

export function consumeMfaSession(): MfaSession | null {
    const s = session;
    session = null;
    return s;
}
